import axios from 'axios';
import addAlert from 'ps-components/AlertToast/addAlert';
import { useCallback } from 'react';
import { useQuery } from 'react-query';

export const textOptions = [
  { text: 'Contains', key: 'like' },
  { text: 'Does not Contain', key: 'nlike' },
  { text: 'Starts With', key: 'start' },
  { text: 'Ends With', key: 'end' },
  { text: 'Equals', key: 'eq' },
  { text: 'Does not Equal', key: 'neq' },
  { text: 'Is Empty', key: 'isNull' },
  { text: 'Is Not Empty', key: 'isNotNull' }
];

export const numberOptions = [
  { text: 'Greater Than', key: 'gt' },
  { text: 'Greater Than or Equal', key: 'gte' },
  { text: 'Less Than', key: 'lt' },
  { text: 'Less Than or Equal', key: 'lte' },
  { text: 'Equals', key: 'eq' },
  { text: 'Is Empty', key: 'isNull' },
  { text: 'Is Not Empty', key: 'isNotNull' }
];

export const DATA_SOURCE = {
  ORG_EMPLOYEES: {
    id: 3,
    label: 'Employee Table'
  },
  JOBS: {
    id: 4,
    label: 'Job Table',
    excludedFields: ['payscale_job_info']
  }
};

export async function getElements(maid, categoryCode, categoryTableFilter) {
  return await axios
    .get(`/cms/api/accounts/${maid}/element-tree`, {
      params: {
        categoryCode,
        elementsTreeFlattened: false
      }
    })
    .then(result => {
      const elements = [];
      const dataSources = Object.values(DATA_SOURCE);
      const filteredDataSources =
        categoryTableFilter && categoryTableFilter.length > 0
          ? dataSources.filter(dataSource => categoryTableFilter.includes(dataSource))
          : dataSources;
      result?.data?.data?.tree?.forEach(category => {
        const foundDataSource = filteredDataSources.find(dataSource => dataSource.label === category.text);
        if (categoryTableFilter.length === 0 || foundDataSource) {
          category.children?.forEach(section => {
            section.children?.forEach(field => {
              const dataSourceLength = field.nonaggregate_data_sources?.length;
              if (
                field.source_field &&
                !field.source_field.includes('->') &&
                !field.source_field.includes('udf_') &&
                !field.source_field.includes('date') && // not supporting dates on first pass
                dataSourceLength === 1 &&
                !field.formula_pk &&
                !shouldExcludeField(field, foundDataSource)
              ) {
                elements.push(field);
              }
            });
          });
        }
      });
      return elements;
    })
    .catch(error => {
      const errorMessage = `Error retrieving employee filter items`;
      addAlert(errorMessage, 'danger');
      console.error(error);
      throw error;
    });
}

function shouldExcludeField(field, dataSource) {
  if (!dataSource.excludedFields) {
    return false;
  }
  if (dataSource.excludedFields.includes(field.source_field)) {
    return true;
  }
  if (dataSource.excludedFields.some(excludedField => field.source_field.startsWith(`${excludedField} - `))) {
    return true;
  }
  return false;
}

export function useElements(maid, categoryCode, categoryTableFilter) {
  const getUrl = `/cms/api/accounts/${maid}/element-tree`;
  const populateElements = useCallback(async () => await getElements(maid, categoryCode, categoryTableFilter), [
    getUrl,
    categoryCode,
    categoryTableFilter
  ]);
  return {
    key: getUrl,
    ...useQuery([getUrl, categoryCode, categoryTableFilter], populateElements, { staleTime: Infinity })
  };
}
